import { render, staticRenderFns } from "./companyTarget.vue?vue&type=template&id=45e8a928"
import script from "./companyTarget.vue?vue&type=script&lang=js"
export * from "./companyTarget.vue?vue&type=script&lang=js"
import style0 from "./companyTarget.vue?vue&type=style&index=0&id=45e8a928&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports